<template>
<div class="chapter">
<div class="inner_page">
<figure epub:type="cover" style="text-align:center;">
<img alt="" role="doc-cover" src="image/CVR_la_profecia_del_dragon.jpg" style="max-width:100%;"/>
</figure>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?5f44e7ae